/**
 * 計助: バックエンド API でユーザー別データルート（uploads/keisuke-users/{userId}/）を参照
 */

import api from '../../api';

export interface KeisukeFilesystemRoot {
  path: string;
  exists: boolean;
  platform: string;
  scopedToUserId?: number;
}

export interface KeisukeFilesystemEntry {
  name: string;
  isDirectory: boolean;
}

export async function getKeisukeFilesystemRoot(): Promise<KeisukeFilesystemRoot | null> {
  try {
    const res = await api.get<KeisukeFilesystemRoot>('/keisuke/filesystem/root');
    return res.data ?? null;
  } catch {
    return null;
  }
}

export async function getKeisukeFilesystemEntries(relativePath: string): Promise<KeisukeFilesystemEntry[]> {
  try {
    const res = await api.get<{ entries: KeisukeFilesystemEntry[] }>('/keisuke/filesystem/entries', {
      params: { path: relativePath },
    });
    return res.data?.entries ?? [];
  } catch {
    return [];
  }
}

export async function getKeisukeFileContentFromApi(relativePath: string): Promise<unknown | null> {
  try {
    const res = await api.get<unknown>('/keisuke/filesystem/file', {
      params: { path: relativePath },
    });
    return res.data ?? null;
  } catch {
    return null;
  }
}
